import { NotificationProps } from '@oneaudi/unified-web-alpha-components';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '~/app/contexts/app-context';
import { i18nKeys, useI18n } from '~/app/i18n/i18n';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { resolveHref } from '~/app/utils/resolve-relative-url';

export const useSaveConfigurationNotification = () => {
	const { i18n } = useI18n();
	const dispatch = useAppDispatch();
	const [notification, setNotification] = useState<{
		message?: keyof typeof i18nKeys;
		isError: boolean;
	}>({
		message: undefined,
		isError: true,
	});

	useEffect(() => {
		if (notification.message) {
			const _notification: NotificationProps = {
				title: {
					text: i18n(
						notification.isError
							? 'ngc.saveConfiguration.error.title'
							: 'ngc.saveConfiguration.success.title',
					),
					tag: 'h1',
				},
				copy: i18n(notification.message),
				icon: notification.isError ? 'caution' : 'select-circle',
				textLink: {
					children: i18n('ngc.saveConfiguration.myAudi.wishlist'),
					href: i18n('ngc.saveConfiguration.myAudi.wishlist.url'),
					icon: 'external-link',
					iconPosition: 'trailing',
					onClick: () => {
						appTrackingService.summaryClickEvent({
							eventAction: EventAction.InternalLink,
							eventName: `configurator (save configuration) - click to open wishlist`,
							componentName: 'configurator-save-configuration',
							label: i18n('ngc.saveConfiguration.myAudi.wishlist'),
							elementName: 'text link',
							targetURL: resolveHref(i18n('ngc.saveConfiguration.myAudi.wishlist.url')),
						});
					},
				},
			};
			dispatch({ type: 'SET_NOTIFICATION_DATA', payload: _notification });

			appTrackingService.saveConfiguration({
				eventName: `configurator (save configuration) - save configuration ${notification.isError ? 'error' : 'success'} message`,
				componentName: 'configurator-save-configuration',
			});
		}
	}, [notification]);
	return { showNotification: setNotification };
};
